export var CheckInContextTypeApi;
(function (CheckInContextTypeApi) {
    CheckInContextTypeApi["PROJECT"] = "project";
})(CheckInContextTypeApi || (CheckInContextTypeApi = {}));
export var CheckInScheduleTypeApi;
(function (CheckInScheduleTypeApi) {
    CheckInScheduleTypeApi["DAILY"] = "daily";
    CheckInScheduleTypeApi["WEEKLY"] = "weekly";
    CheckInScheduleTypeApi["MONTHLY"] = "monthly";
    CheckInScheduleTypeApi["MUTED"] = "muted";
})(CheckInScheduleTypeApi || (CheckInScheduleTypeApi = {}));
export var UserIdsConditionTypeApi;
(function (UserIdsConditionTypeApi) {
    UserIdsConditionTypeApi["AND"] = "and";
    UserIdsConditionTypeApi["OR"] = "or";
})(UserIdsConditionTypeApi || (UserIdsConditionTypeApi = {}));
